import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import styles from "./AboutUs.module.css";
import { fetchAboutUs } from "./aboutusSlice";

const AboutUs = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const aboutData = useSelector(function (state) {
    return state.aboutUs.data;
  });

  var currentLanguage =
    i18n.resolvedLanguage || i18n.language || "en";

  currentLanguage = currentLanguage.split("-")[0];

  useEffect(
    function () {
      dispatch(fetchAboutUs(currentLanguage));
    },
    [dispatch, currentLanguage]
  );

  var title = t("about.title");
  var description = t("about.description");
  var image = "/Frame 10.png";

  if (aboutData) {
    title = aboutData.title || title;
    description = aboutData.description || description;
    image = aboutData.image || image;
  }

  return (
    <section className={styles.aboutSection} id="about">
      <div className="container">
        <div>
          <span className={styles.subTitle}>
            {t("about.subtitle")}
          </span>

          <h2 className={styles.mainTitle}>{title}</h2>
        </div>

        <div className="row align-items-center text-start">
          <div className="col-lg-6 ps-lg-5 text-start">
            <p className={styles.description}>{description}</p>

            <div className={styles.featuresList}>
              <div className={styles.featureItem}>
                <div className={styles.featureIcon}>
                  <i className="bi bi-journal-richtext"></i>
                </div>

                <div>
                  <h4>{t("about.feature1Title")}</h4>
                  <p>{t("about.feature1Desc")}</p>
                </div>
              </div>

              <div className={styles.featureItem}>
                <div className={styles.featureIcon}>
                  <i className="bi bi-mic-fill"></i>
                </div>

                <div>
                  <h4>{t("about.feature2Title")}</h4>
                  <p>{t("about.feature2Desc")}</p>
                </div>
              </div>
            </div>

            <button className={styles.btnDiscovery}>
              {t("about.button")}
            </button>
          </div>

          <div className="col-lg-6 mb-5 mb-lg-0 text-center">
            <div className={styles.imageWrapper}>
              <div className={styles.experienceBadge}>
                <span>{t("about.since")}</span>
                <strong>2006</strong>
              </div>

              <img
                src={image}
                alt={title}
                className="img-fluid rounded-3"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUs);